module.exports = __webpack_public_path__ + "static/img/exchange-funds-fill.b7ad9a42.png";